import React from 'react';
import './BCases.css';

function BCases({ id }) {
  return (
    <section className="b-case-studies-section" id={id || 'cases'}>
      <div className="container">
        <h2 className="section-title">
          Empresas que <span className="highlight-blue">transformaron</span> sus equipos
        </h2>
      </div>
    </section>
  );
}

export default BCases;